<template>
  <div id="app">
    <Header />
    <router-view />
    <Consult />
    <AnswerDownload />
    <Partner />
    <Footer />
  </div>
</template>
<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Consult from './components/consult.vue';
import AnswerDownload from './components/answerDownload.vue';
import Partner from './components/partner.vue';

import './assets/css/common.scss';
import './assets/css/color.scss';

export default {
  name: 'App',
  components: {
    Header,
    Consult,
    Footer,
    AnswerDownload,
    Partner
  },
  // 监听路由变化，确保页面跳转后滚动到顶部
  watch: {
    '$route': function(to, from) {
      // 确保在路由切换时滚动到页面顶部
      window.scrollTo(0, 0);
    }
  }
}
</script>
<style>
/* 全局样式 */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  background-color: #f5f5f5;
  line-height: 1.6;
}

/* 泰文字体 */
.thai {
  font-family: "Noto Sans Thai", "Roboto", sans-serif;
}

/* 阿拉伯语字体和RTL支持 */
.arabic {
  font-family: "Noto Sans Arabic", "Roboto", sans-serif;
}

.rtl {
  direction: rtl;
  text-align: right;
}

.rtl .el-input-group__append {
  border-radius: 4px 0 0 4px;
}

.rtl .el-input-group__prepend {
  border-radius: 0 4px 4px 0;
}

/* Element UI 组件的RTL适配 */
.rtl .el-dropdown {
  direction: rtl;
}

.rtl .el-dropdown-menu {
  direction: rtl;
  text-align: right;
}

.rtl .el-button-group .el-button:first-child {
  border-radius: 0 4px 4px 0;
}

.rtl .el-button-group .el-button:last-child {
  border-radius: 4px 0 0 4px;
}

.rtl .el-rate {
  direction: ltr; /* 评分组件保持从左到右 */
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 加载状态 */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #666;
}

/* 错误状态 */
.error {
  text-align: center;
  color: #e53238;
  padding: 40px;
}

/* 空状态 */
.empty {
  text-align: center;
  color: #999;
  padding: 40px;
}
</style>
